import { useState } from "react";

import { verifyTVCode } from "_services/api/user";

import Presentation from "./presentation";

const Component = () => {
	// codeError;
	const [ code, setCode ]                         = useState ( "" );
	const [ codeError, setCodeError ]               = useState ( "" );
	const [ isTVActivated, setIsTVActivated ]       = useState ( "" );
	const [ isSendingCode, setIsSendingCode ]       = useState ( false );
	const [ hoverImage, setHoverImage ]             = useState ( false );
	const [ popperElement, setPopperElement ]       = useState ( null );
	const [ referenceElement, setReferenceElement ] = useState ( null );

	const handleCodeChange = value => {
		setCode ( value.toUpperCase () );
	};

	const onSubmitHandler = async () => {
		try {
			setIsSendingCode ( true );
			const response = await verifyTVCode ( { code } );

			if ( response.status === "suc`cess" ) {
				setIsTVActivated ( true );
			}
			setIsSendingCode ( false );

		} catch ( error ) {
			setCodeError ( "You’ve entered a wrong code" );
			setIsSendingCode ( false );
		}
	};

	let timerEnter, timerExit;

	const handleHoverEnter = () => {
		clearTimeout ( timerExit );
		timerEnter = setTimeout ( () => {
			setHoverImage ( true );
		}, 500 );
	};

	const handleHoverExit = () => {
		clearTimeout ( timerEnter );
		timerExit = setTimeout ( () => {
			setHoverImage ( false );
		}, 500 );

	};

	return (
		<Presentation
			code                = { code }
			codeError           = { codeError }
			handleCodeChange    = { handleCodeChange }
			handleHoverEnter    = { handleHoverEnter }
			handleHoverExit     = { handleHoverExit }
			hoverImage          = { hoverImage }
			isSendingCode       = { isSendingCode }
			isTVActivated       = { isTVActivated }
			onSubmitHandler     = { onSubmitHandler }
			popperElement       = { popperElement }
			referenceElement    = { referenceElement }
			setPopperElement    = { setPopperElement }
			setReferenceElement = { setReferenceElement }
		/>
	);
};

export default Component;